import { ROTULO_DO_MOTOR } from '@remoto/protocolo';
import { motorDaLinha, seloDoMotor } from '../sessoes/motor-na-tela';

/**
 * O selo do motor numa LINHA da lista de sessões.
 *
 * Só aparece no que foge do padrão da casa (`seloDoMotor().naLista`): marcar
 * todas encheria a lista inteira de etiqueta e faria a informação virar
 * textura — numa frota de trinta conversas do Claude, o que se precisa ver é a
 * que não é. Com três motores, isso quer dizer Codex E OpenCode: o ternário de
 * antes (`motor === 'CODEX' ? selo : nada`) deixava a conversa do OpenCode sem
 * marca nenhuma, parecendo do Claude.
 *
 * TEXTO, nunca só cor: a cor é o reforço. Motor desconhecido não ganha selo —
 * sem saber o nome, qualquer rótulo seria chute.
 */
export function SeloDoMotorNaLista({ motor }: { motor?: string | null }): React.JSX.Element | null {
  const lido = motorDaLinha(motor);
  if (lido === null) return null;
  const selo = seloDoMotor(lido);
  if (!selo.naLista) return null;
  return (
    <span
      data-teste="selo-de-motor"
      title={'Esta conversa roda no ' + ROTULO_DO_MOTOR[lido]}
      className={'mr-1 rounded px-1 py-0.5 text-[10px] uppercase tracking-wide ' + selo.cor}
    >
      {ROTULO_DO_MOTOR[lido]}
    </span>
  );
}
